var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290,
    zoomAndPan: "magnify",
    viewBox: "0 0 217.5 217.499992",
    height: 290,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ae14b8b459"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.792969 49.792969 L 167.273438 49.792969 L 167.273438 167.273438 L 49.792969 167.273438 Z M 49.792969 49.792969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c0262d4400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.0625 81.0625 L 135.6875 81.0625 L 135.6875 135.6875 L 81.0625 135.6875 Z M 81.0625 81.0625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae14b8b459)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3184c9",
    d: "M 149.140625 49.792969 L 67.855469 49.792969 C 57.878906 49.792969 49.792969 57.878906 49.792969 67.855469 L 49.792969 149.140625 C 49.792969 159.113281 57.878906 167.203125 67.855469 167.203125 L 149.140625 167.203125 C 159.113281 167.203125 167.203125 159.113281 167.203125 149.140625 L 167.203125 67.855469 C 167.203125 57.878906 159.113281 49.792969 149.140625 49.792969 Z M 158.171875 149.140625 C 158.171875 154.125 154.121094 158.171875 149.140625 158.171875 L 67.855469 158.171875 C 62.871094 158.171875 58.824219 154.125 58.824219 149.140625 L 58.824219 67.855469 C 58.824219 62.875 62.871094 58.824219 67.855469 58.824219 L 149.140625 58.824219 C 154.121094 58.824219 158.171875 62.875 158.171875 67.855469 Z M 158.171875 149.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c0262d4400)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f20f10",
    d: "M 133.816406 133.816406 C 131.945312 135.6875 128.910156 135.6875 127.039062 133.816406 L 82.933594 89.710938 C 81.0625 87.839844 81.0625 84.804688 82.933594 82.933594 C 84.804688 81.0625 87.839844 81.0625 89.710938 82.933594 L 133.816406 127.039062 C 135.6875 128.910156 135.6875 131.945312 133.816406 133.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f20f10",
    d: "M 82.933594 133.816406 C 81.0625 131.945312 81.0625 128.910156 82.933594 127.039062 L 127.039062 82.933594 C 128.910156 81.0625 131.945312 81.0625 133.816406 82.933594 C 135.6875 84.804688 135.6875 87.839844 133.816406 89.710938 L 89.710938 133.816406 C 87.839844 135.6875 84.804688 135.6875 82.933594 133.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.6c42eefaf602bbc033e99a1e5d4b8abc.svg";
export { ForwardRef as ReactComponent };